module.exports = __webpack_public_path__ + "img/r5c2.415907cb.jpg";